import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";

let lastNetworkErrorShownAt = 0;
const NETWORK_ERROR_DEBOUNCE_MS = 5000;

// Multiple queries can fail simultaneously when offline. Without debouncing,
// each failure would show its own snackbar. We only need one.
export function showNetworkErrorSnackbar() {
    const now = Date.now();
    if (now - lastNetworkErrorShownAt > NETWORK_ERROR_DEBOUNCE_MS) {
        lastNetworkErrorShownAt = now;
        enqueueSnackbar("Network request failed. Please check your internet connection and try again.", {
            variant: "error",
            alertTitle: "Connection error",
        });
    }
}

export function resetNetworkErrorDebounce() {
    lastNetworkErrorShownAt = 0;
}
